import search from './search';
import transformScopes from './transform-scopes';

export default {
	search,
	transformScopes
};
